export function formatStartToEndTime(startTime: Date, endTime: Date): string {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
  };

  return `${startTime.toLocaleString('th-TH', options)} - ${endTime.toLocaleString('th-TH', options)} น.`;
}
